import React, { Component } from "react";
import { Header } from "./components/Header";
import { IntroPage } from "./pages/IntroPage";
import { SectionContainer } from "../library/utilities/SectionContainer";
import { ColorGrayscale } from "../library/utilities/variables";
import { QuestionsService } from "./services/QuestionsService";
import styled, { ThemeProvider } from "styled-components";
import { QuestionPage } from "./pages/QuestionPage";
import { BlueTheme } from "./themes/BlueTheme";
import { OrangeTheme } from "./themes/OrangeTheme";
import { ItineraryPage } from "./pages/ItineraryPage";
import { AnimateSharedLayout } from "framer-motion";
import { ItineraryService } from "./services/ItineraryService";
import { LinksService } from "../library/services/LinksService";
const AppLayoutContainer = styled.div `
    display: flex;
    flex-direction: column;
    align-items: stretch;
    min-height: 100vh;

    transition: background 300ms ease-in-out;

    background: ${({ background }) => background || 'white'};
`;
const AppLayoutMain = styled.main `
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    & > ${SectionContainer} {
        flex-grow: 1;
    }
`;
export class QuizApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            questions: null,
            currentQuestion: null,
            answers: [],
            comesFromBacktracking: false,
            backgroundColor: ColorGrayscale.white,
            currentQuizTheme: BlueTheme,
            finalItinerary: null,
            links: {}
        };
        this.onClose = this.onClose.bind(this);
        this.onBack = this.onBack.bind(this);
        this.onFirstQuestionAnswered = this.onFirstQuestionAnswered.bind(this);
        this.onQuestionAnswered = this.onQuestionAnswered.bind(this);
        this.onChangeBackground = this.onChangeBackground.bind(this);
    }
    componentDidMount() {
        this.setQuestions();
        this.getLinks();
    }
    setQuestions() {
        QuestionsService.getQuestions().then(questions => {
            this.setState((prevState) => ({
                ...prevState,
                questions: questions,
                currentQuestion: questions
            }));
        });
    }
    getLinks() {
        LinksService.getLinks().then(links => {
            this.setState((prevState) => ({
                ...prevState,
                links
            }));
        });
    }
    getItinerary(itineraryNode) {
        ItineraryService.getItinerary(itineraryNode.itinerary)
            .then(itinerary => {
            this.setState(prevState => ({
                ...prevState,
                finalItinerary: itinerary
            }));
        });
    }
    preloadImages(images) {
        images.forEach(imageUrl => new Image().src = imageUrl);
    }
    onClose() {
        window.open('/', '_self');
    }
    onBack() {
        this.setState((prevState) => {
            const answers = prevState.answers;
            answers.pop();
            const currentQuestion = answers[answers.length - 1] || prevState.questions;
            return {
                ...prevState,
                currentQuestion: currentQuestion,
                comesFromBacktracking: true,
                answers: [
                    ...answers
                ],
            };
        });
    }
    onFirstQuestionAnswered(answer) {
        const currentTheme = answer.theme === 'blue' ? BlueTheme : OrangeTheme;
        this.preloadImages([
            currentTheme.feedbackBackgroundUrl,
            currentTheme.character.start,
            currentTheme.character.middle,
            currentTheme.character.end,
            '/static/website/images_apps/pages/itinerary/background.svg',
            '/static/website/images_apps/pages/itinerary/background-desktop.svg'
        ]);
        this.setState((prevState) => ({
            ...prevState,
            currentQuizTheme: currentTheme,
            currentQuestion: answer,
            comesFromBacktracking: false,
            answers: [
                ...prevState.answers,
                answer
            ],
        }));
    }
    onQuestionAnswered(answer) {
        if (answer.node_type === 'itinerary') {
            this.getItinerary(answer);
        }
        this.setState((prevState) => ({
            ...prevState,
            currentQuestion: answer,
            comesFromBacktracking: false,
            answers: [
                ...prevState.answers,
                answer
            ],
        }));
    }
    onChangeBackground(color) {
        this.setState(prevState => ({
            ...prevState,
            backgroundColor: color
        }));
    }
    get showIntro() {
        return this.state.answers.length < 1;
    }
    get showQuestion() {
        return this.state.answers.length >= 1 && this.state.currentQuestion.node_type === 'question';
    }
    get showResponse() {
        return this.state.answers.length >= 1 && this.state.currentQuestion.node_type !== 'question';
    }
    get showBack() {
        return this.state.answers.length > 0 && this.state.currentQuestion.node_type === 'question';
    }
    render() {
        return (React.createElement(AppLayoutContainer, { background: this.state.backgroundColor },
            React.createElement(Header, { onCloseClick: this.onClose, onBackClick: this.onBack, showBack: this.showBack, positioningAbove: !!this.state.finalItinerary }),
            React.createElement(AppLayoutMain, null,
                React.createElement(ThemeProvider, { theme: this.state.currentQuizTheme },
                    React.createElement(AnimateSharedLayout, { type: "crossfade" },
                        this.showIntro && (React.createElement(IntroPage, { key: "IntroPage", question: this.state.currentQuestion, onFirstQuestionAnswered: this.onFirstQuestionAnswered, changeBackgroundColor: this.onChangeBackground, comesFromBacktracking: this.state.comesFromBacktracking })),
                        this.showQuestion && (React.createElement(QuestionPage, { key: "QuestionPage", question: this.state.currentQuestion, questionPosition: this.state.answers.length, comesFromBacktracking: this.state.comesFromBacktracking, changeBackgroundColor: this.onChangeBackground, onAnswered: this.onQuestionAnswered })),
                        this.showResponse && (React.createElement(ItineraryPage, { key: "ItineraryPage", itineraryNode: this.state.currentQuestion, itinerary: this.state.finalItinerary, links: this.state.links })))))));
    }
}
